import { Polygon } from './polygon';

export class Blob extends Polygon {
  protected isSmoothFigure() {
    return true;
  }
}